import classNames from "classnames";

export interface HeaderProps {
  children?: React.ReactNode;
  className?: string;
}

export const Header = ({ children, className = "", ...rest }: HeaderProps) => (
  <header
    className={classNames(
      "bg-primary border-primary grid-in-header size-full overflow-x-auto border-b",
      className,
    )}
    {...rest}
  >
    {children}
  </header>
);
